export default __webpack_public_path__ + "static/media/causes-4.ca5b39c5.png";